import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { firstValueFrom, Observable, Subject } from 'rxjs';
import { CreateCertificate } from 'app/dtos/certificate/createCertificate';
import { UpdateCertificate } from 'app/dtos/certificate/updateCertificate';
import { sendCertificateDTO } from 'app/dtos/mail/sendCertificateDTO';
import { HttpHeaders } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class CertificateService {

  constructor(private httpClientService: HttpClientService) { }

  async getByIdDeviceCertificates(page, size, id) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Certificate,
      action: "GetByIdDeviceCertificates",
      queryString: `Page=${page}&Size=${size}`
    }, id);
    return await firstValueFrom(observable);
  }

  async getLastCertificate() {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Certificate,
      action: "GetLastCertificate"
    });
    return await firstValueFrom(observable);
  }

  async gelAllCertificates(page, size, companyId?: number, expiryStartDate?: string, expiryEndDate?: string, certificateNo?: string, status?: number, acreditationCompanyId?: number) {
    let queryParams = `Page=${page}&Size=${size}`;

    if (companyId) queryParams += `&CompanyId=${companyId}`;
    if (expiryStartDate) queryParams += `&ExpiryStartDate=${expiryStartDate}`;
    if (expiryEndDate) queryParams += `&ExpiryEndDate=${expiryEndDate}`;
    if (certificateNo) queryParams += `&CertificateNo=${certificateNo}`;
    if (status) queryParams += `&Status=${status}`;
    if (acreditationCompanyId) queryParams += `&AcreditationCompanyId=${acreditationCompanyId}`;

    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Certificate,
      queryString: queryParams
    });
    return await firstValueFrom(observable);
  }

  async createCertificate(createCertificate: CreateCertificate) {
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.Certificate
    },
      {
        certificateNo: createCertificate.certificateNo,
        issueDate: createCertificate.issueDate,
        expiryDate: createCertificate.expiryDate,
        calibrationId: createCertificate.calibrationId,
        //base64Data: createCertificate.base64Data,
        personId: createCertificate.personId
      });
    return await firstValueFrom(observable);
  }

  async sendCertificate(sendCertificateDTO: sendCertificateDTO) {
    const action = 'SendCertificate';
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.Certificate,
      action
    }, sendCertificateDTO);

    return await firstValueFrom(observable);
  }

  async getByIdCertificate(id) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Certificate
    }, id);
    return await firstValueFrom(observable);
  }

  async updateCertificate(updateCertificate: UpdateCertificate) {
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.Certificate
    }, {
     // base64Data: updateCertificate.base64Data,
      id: updateCertificate.id,
      certificateNo: updateCertificate.certificateNo,
      issueDate: updateCertificate.issueDate,
      expiryDate: updateCertificate.expiryDate,
      calibrationId: updateCertificate.calibrationId,
      personId: updateCertificate.personId,
      status: updateCertificate.status,
      filePath: `/Certificates/${updateCertificate.certificateNo}`,
      createCertificateRevise: updateCertificate.createCertificateRevise
    });
    return await firstValueFrom(observable);
  }

  async updateCertificateStatus(id, status) {
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.Certificate,
      action: "UpdateCertificateStatus"
    }, {
      id: id,
      status: status
    });
    return await firstValueFrom(observable);
  }

  async getCompanyByIdCertificates(page, size, id) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Certificate,
      action: "GetByIdCompanyCertificates",
      queryString: `page=${page}&size=${size}&id=${id}`
    });
    return await firstValueFrom(observable);
  }

  async getLastCertificatePdf(id): Promise<ArrayBuffer> {
    const observable: Observable<ArrayBuffer> = this.httpClientService.get({
      controller: ControllerType.Certificate,
      action: `last`,
    }, id, 'arraybuffer');
    return await firstValueFrom(observable);
  }

  async GetByIdCustomerCertificates(page, size, id, accessKey) {
    let queryParams = `Page=${page}&Size=${size}`;

    if (id) queryParams += `&id=${id}`;
    if (accessKey) queryParams += `&accessKey=${accessKey}`;

    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Certificate,
      action: "GetByIdCustomerCertificates",
      queryString: queryParams
    });
    return await firstValueFrom(observable);
  }

  async GetByIdCustomerCertificatesExpiry(page, size, id, accessKey) {
    let queryParams = `Page=${page}&Size=${size}`;

    if (id) queryParams += `&id=${id}`;
    if (accessKey) queryParams += `&accessKey=${accessKey}`;

    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Certificate,
      action: "GetByIdCustomerCertificatesExpiry",
      queryString: queryParams
    });
    return await firstValueFrom(observable);
  }

  async deleteCertificate(id, token?: string) {
    const options: any = {
      controller: ControllerType.Certificate
    };

    // 🔥 Token varsa header'a ekle
    if (token) {
      options.headers = new HttpHeaders({
        token: token
      });
    }

    const observable: Observable<any> = this.httpClientService.delete(options, id);
    return await firstValueFrom(observable);
  }

  async saveCertificateBase64(id, base64, certificateNo, calibrationNo) {
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.Certificate,
      action: "SaveCertificateBase64"
    }, {
      id: id,
      base64: base64,
      certificateNo: certificateNo,
      calibrationNo: calibrationNo
    });
    return await firstValueFrom(observable);
  }

  private eventSubject = new Subject<boolean>();

  event$ = this.eventSubject.asObservable();

  sendEvent(result: boolean) {
    this.eventSubject.next(result);
  }
}
